import { env } from 'config';
import {
  RequisitesDistribution,
  RequisitesDistributionDebug,
  PaginatedData,
  QueryParams,
} from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/requisites-distribution`;

const getPaginatedByUrl =
  <T>(url: string) =>
  async (params: QueryParams): Promise<PaginatedData<T>> =>
    (await apiUtils.getWithQueryParams(url, params)).data;

const getCachePaginated = getPaginatedByUrl<RequisitesDistribution>(
  `${url}/cache`,
);
const getDebugPaginated = getPaginatedByUrl<RequisitesDistributionDebug>(
  `${url}/debug`,
);

export const requisitesDistributionApi = {
  getCachePaginated,
  getDebugPaginated,
};
